import {
  Avatar,
  Box,
  Container,
  Grid,
  Button,
  styled,
  Typography,
  Tabs,
  Tab,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import SocialMediaPostCompact from "./SocialMediaPostCompact";
import { useInfiniteUserPosts } from "../api/getUserPosts";
import { useGetUserSocialProfile } from "../api/getUserSocialProfile";
import { baseUrl } from "../../../shared/config";
import {
  Collections,
  Contacts,
  Email,
  EmojiEvents,
  Facebook,
  Instagram,
  KeyboardReturn,
  LinkedIn,
  ManageAccounts,
  QrCode,
  Star,
  StarBorder,
} from "@mui/icons-material";
import SideBar from "./Layout/SideBar";

import StudentGames from "./StudentGamesPanel";
import StudentCoursesPanel from "./StudentCoursesPanel";
import StudentTracksPanel from "./StudentTracksPanel";

import Navbar from "../../../ui/blocks/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import StudentContacts from "./StudentContacts";

import _cookies from "../../../shared/utils/_cookies";

import EditProfile from "./EditProfile";

import AddUserToCloseFriends from "./AddUserToCloseFriends";
import { DirectMessagesDialog } from "./DirectMessages";
import QrCodeDialog from "../../../ui/components/QrCodeDialog/QRCodeDialogV2";
import { useInView } from "react-intersection-observer";

const UserHeader = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(1),
  },
  height: "fit-content",
  borderBottom: `1px solid ${theme.palette.primary.main}`,
  marginBottom: theme.spacing(2),

  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  "& a": {
    color: "#00376b",
    display: "flex",
    alignItems: "center",
  },
}));

const StyledContainer = styled(Container)(({ theme }) => ({
  overflow: "visible",
  height: "fit-content",
  [theme.breakpoints.down("md")]: {
    width: "min(100vw, 500px)",
  },
  [theme.breakpoints.up("md")]: {
    ".user_info_section": {
      display: "none",
    },
  },
  [theme.breakpoints.up("lg")]: {
    width: "min(100vw, 550px)",
  },
  [theme.breakpoints.up("xl")]: {
    width: "min(100vw, 550px)",
  },
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  width: "100%",
  ".tab_achievements": {
    [theme.breakpoints.up("md")]: {
      display: "none  ",
    },
  },
}));

export default function MyProfile() {
  const params = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const bottomEl = useInView();
  const [currentTab, setCurrrentTab] = useState("posts");
  const studentId = params.studentId;

  useEffect(() => {
    document.getElementById("pr_layout_container").style.height =
      "calc(100dvh - 64px)";
    document.getElementById("navbar_container").style.position = "fixed";
    document.getElementById("navbar_toggle_button").style.marginTop = "-70px";
  }, []);
  const userPostsQuery = useInfiniteUserPosts({ studentId });
  const profileDataQuery = useGetUserSocialProfile({ studentId });

  const handleChangeTab = (event, newValue) => {
    setCurrrentTab(newValue);
  };

  const showLink = (propName) => {
    return profileDataQuery.data?.[propName]?.[0] === "1";
  };

  const isABot = Number(studentId) >= 9000000;
  const isThisUserProfile =
    Number(studentId) === _cookies.getItem("auth").user.alunoid;
  const showSendEmailButton = () => !isThisUserProfile && !isABot;
  const showEditProfileButton = () => isThisUserProfile;
  const showAddToCloseFriends = () => !isThisUserProfile && !isABot;
  const showQRCodeButton = () => !isABot;
  const showTabContent = (type) => type === currentTab;
  const handleClickGoBack = () => {
    navigate(-1);
  };
  const handleBottomEntersView = () => {
    if (userPostsQuery.hasNextPage && !userPostsQuery.isFetchingNextPage) {
      userPostsQuery.fetchNextPage();
    }
  };
  useEffect(() => {
    if (bottomEl?.inView) {
      handleBottomEntersView();
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bottomEl?.inView]);
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        margin: "0 auto",
        overflow: "auto",
        flexDirection: "column",

        width: "100%",
      }}
    >
      <StyledContainer disableGutters>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: { xs: "32px", md: "24px" },
            paddingX: { xs: 1, md: "0px" },
            marginTop: 1,

            ".MuiButton-root": {
              padding: "0",
            },
          }}
        >
          <Button onClick={handleClickGoBack} startIcon={<KeyboardReturn />}>
            Voltar
          </Button>
          <span className="flex gap-1">
            {showAddToCloseFriends() && (
              <AddUserToCloseFriends
                studentId={studentId}
                added={profileDataQuery.data?.favoritado === "S"}
              >
                {({ mutate }) => {
                  return (
                    <Button
                      sx={{
                        backgroundColor: theme.palette.success.main,
                      }}
                      onClick={mutate}
                      variant="contained"
                    >
                      {profileDataQuery.data?.favoritado === "S" ? (
                        <Star />
                      ) : (
                        <StarBorder />
                      )}
                    </Button>
                  );
                }}
              </AddUserToCloseFriends>
            )}
            {showSendEmailButton() && (
              <DirectMessagesDialog studentId={studentId}>
                {({ openDialog }) => {
                  return (
                    <Button
                      sx={{ ml: "auto" }}
                      variant="contained"
                      onClick={openDialog}
                    >
                      <Email />
                    </Button>
                  );
                }}
              </DirectMessagesDialog>
            )}

            {showEditProfileButton() && (
              <EditProfile
                defaultValues={{
                  instagramURL: profileDataQuery.data?.instagram
                    .split("/")
                    .at(-1),
                  instagramURLVisibility: Boolean(
                    Number(profileDataQuery.data?.instagram[0])
                  ),
                  linkedinURL: profileDataQuery.data?.linkedn.split("/").at(-1),
                  linkedinURLVisibility: Boolean(
                    Number(profileDataQuery.data?.linkedn[0])
                  ),
                  facebookURL: profileDataQuery.data?.facebook
                    .split("/")
                    .at(-1),
                  facebookURLVisibility: Boolean(
                    Number(profileDataQuery.data?.facebook[0])
                  ),
                }}
                currentProfilePicture={`${baseUrl}/membros/fotos/${profileDataQuery.data?.foto}`}
              >
                {({ openDialog }) => {
                  return (
                    <Button variant="contained" onClick={openDialog}>
                      <ManageAccounts />
                    </Button>
                  );
                }}
              </EditProfile>
            )}
            {showQRCodeButton() && (
              <QrCodeDialog
                title="Link do perfil"
                url={`${baseUrl}/aluno?type=/social/perfil/${studentId}`}
              >
                {({ openDialog }) => {
                  return (
                    <Button onClick={openDialog} variant="contained">
                      <QrCode />
                    </Button>
                  );
                }}
              </QrCodeDialog>
            )}
          </span>
        </Box>
        <UserHeader>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
            component="span"
          >
            <Avatar
              sx={{ height: "100px", width: "100px" }}
              src={`${baseUrl}/membros/fotos/${profileDataQuery.data?.foto}`}
            />
            <Grid container spacing={1}>
              <Grid item container gap={1} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",

                    justifyContent: "space-between",
                    span: {
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      gap: 1,
                    },
                  }}
                >
                  <Typography variant="h6" sx={{ flexGrow: "1" }}>
                    {profileDataQuery.data?.nomeAluno}
                  </Typography>
                </Box>
              </Grid>

              <Grid item container xs={6}>
                {showLink("facebook") && (
                  <Grid item xs={12}>
                    <Typography
                      component={"a"}
                      href={profileDataQuery.data?.facebook.slice(1)}
                      target="_blank"
                      variant="subtitle2"
                    >
                      <Facebook />
                      Facebook
                    </Typography>
                  </Grid>
                )}
                {showLink("instagram") && (
                  <Grid xs={12}>
                    <Typography
                      component={"a"}
                      href={profileDataQuery.data?.instagram.slice(1)}
                      target="_blank"
                      variant="subtitle2"
                    >
                      <Instagram />
                      Instagram
                    </Typography>
                  </Grid>
                )}
                {showLink("linkedn") && (
                  <Grid xs={12} md={4}>
                    <Typography
                      component={"a"}
                      href={profileDataQuery.data?.linkedn.slice(1)}
                      target="_blank"
                      variant="subtitle2"
                    >
                      <LinkedIn />
                      Linkedin
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Box>
        </UserHeader>
        <Grid container spacing={"2px"}>
          <StyledTabs value={currentTab} onChange={handleChangeTab} centered>
            <Tab value="posts" className="tab_posts" label={<Collections />} />
            <Tab
              value="achievements"
              className="tab_achievements"
              label={<EmojiEvents />}
            />
            <Tab
              value="contacts"
              className="tab_contacts"
              label={<Contacts />}
            />
          </StyledTabs>
          {showTabContent("achievements") && (
            <>
              <StudentCoursesPanel studentId={studentId} />
              <StudentGames studentId={studentId} />
              <StudentCoursesPanel studentId={studentId} />
              <StudentTracksPanel studentId={studentId} />
            </>
          )}
          {showTabContent("posts") && (
            <>
              {userPostsQuery.data?.pages?.map((page) => {
                return page.map((postData) => {
                  return (
                    <>
                      <Grid
                        item
                        xs={4}
                        sx={{
                          ".post_compact_wrapper": {
                            position: "relative",
                            padding: 0,
                            margin: 0,
                          },
                          ".post_compact_thumbnail:not(.post_compact_thumbnail_restrict)":
                            {
                              cursor: "pointer",
                            },

                          ".post_compact_header, .post_compact_footer": {
                            display: "none",
                          },
                          ".post_compact_thumbnail": {
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                          },
                          ".post_content_text": {
                            aspectRatio: "1 / 1",
                            overflow: "hidden",
                          },
                        }}
                      >
                        <SocialMediaPostCompact
                          postData={postData}
                          displayThumbnail
                        />
                      </Grid>
                    </>
                  );
                });
              })}
              <div ref={bottomEl.ref}></div>
            </>
          )}

          {showTabContent("contacts") && (
            <StudentContacts studentId={studentId} />
          )}
        </Grid>
      </StyledContainer>
      <SideBar>
        <StudentGames studentId={studentId} />
        <StudentCoursesPanel studentId={studentId} />
        <StudentTracksPanel studentId={studentId} />
      </SideBar>
      <Navbar />
    </Box>
  );
}
